export const createEventButton: Style = () => ({})
